module.exports = __webpack_public_path__ + "img/egrain2.7da31a5b.png";